/**
 * This file contains the names of all experiment flags used in the application.
 *
 * @example
 * export const ENABLE_EXAMPLE_FLAG = 'enable-example-flag';
 */

export const CVR243_PERSONALIZED_PACKAGE_RECOMMENDATION = 'personalized-package-recommendation';
export const CVR267_COMPLIANCE_TIER_CROSS_SELL = 'cvr-267-compliance-tier-cross-sell';
export const ENABLE_APPLE_PAY = 'enable-apple-pay';
export const ENABLE_CORA_UPSELLS = 'enable-cora-upsells-test';
export const ENABLE_FLOW_STATE_PERSISTENCE = 'enable-flow-state-persistence'
export const ENABLE_FORM_FACTOR_FOR_MOBILE_FLOWS = 'enable-form-factor-for-mobile-flows';
export const ENABLE_GOOGLE_PAY = 'enable-google-pay';
export const ENABLE_RESUME_MODAL = 'enable-resume-modal';
export const ENABLE_SYNCHRONOUS_ORDER_PLACEMENT = 'enable-synchronous-order-placement';
export const MFT22_DEFAULT_PAYMENT_METHOD_TO_APPLE_PAY = 'mft22-default-payment-method-to-apple-pay';
